import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useSendTracking } from 'hooks/useSendTracking';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React from 'react';
import { createHashString } from 'utils';

const useMenuEvents = () => {
  const { isMobile, isTablet } = useDeviceSize();

  const { eventsSource, freight, freightId } = useTruckerProps();

  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const negotiationStartedEvent = (
    eventType: 'whatsapp_disponivel' | 'whatsapp_indisponivel',
    truckerData: ITruckerProfileProps,
    event?: React.MouseEvent
  ) => {
    const negotiationStartedCommomEventProps = {
      type: eventType,
      isVerified: truckerData?.isVerified,
      source: eventsSource,
      device: isMobile || isTablet ? 'mobile' : 'desktop',
    };

    sendAmplitude('trucker_profile_negotiation_started', {
      ...negotiationStartedCommomEventProps,
      freightCode: freight?.code || textConstants.notAvailaible,
      truckerId: truckerData?.trucker?.id,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_negotiation_started',
        data: {
          ...negotiationStartedCommomEventProps,
          freightId: createHashString(freightId),
          truckerId: `hashed|${truckerData?.trucker?.id}`,
        },
        clickEvent: event,
      },
      'trucker_profile'
    );

    /* istanbul ignore else */
    if (eventType === 'whatsapp_disponivel') {
      const vehicle = truckerData?.trucker.vehicles?.[0] ?? null;

      sendTrackingJaiminho(
        {
          nameEvent: 'veiculos-proximos-visualizacao-contato-veiculo',
          clickEvent: event,
          data: {
            plate: vehicle?.tractor.plate ? vehicle?.tractor.plate : textConstants.notAvailaible,
            vehicle_id: createHashString(vehicle?.id),
            freight_id: createHashString(freightId),
            person_id: createHashString(truckerData?.trucker?.id),
            person_uuid: createHashString(truckerData?.trucker?.uuid, ''),
          },
        },
        'events'
      );
    }
  };

  const addRemoveFromContactListEvent = (
    eventType: 'add' | 'exclude' | 'error',
    truckerData: ITruckerProfileProps,
    event?: React.MouseEvent
  ) => {
    const eventCommomProps = {
      type: eventType,
      device: isMobile || isTablet ? 'mobile' : 'desktop',
      source: eventsSource,
      isVerified: truckerData.isVerified,
    };

    sendAmplitude('trucker_profile_contact_clicked', {
      ...eventCommomProps,
      freightCode: freight?.code || textConstants.notAvailaible,
      truckerId: truckerData.trucker?.id,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_contact_clicked',
        data: {
          ...eventCommomProps,
          freightCode: createHashString(freight?.code),
          truckerId: `hashed|${truckerData?.trucker?.id}`,
        },
        clickEvent: event,
      },
      'trucker_profile'
    );
  };

  const modalConfirmRemoveFromContactListEvent = (
    eventType: 'confirmed' | 'canceled' | 'error',
    truckerData: ITruckerProfileProps,
    event?: React.MouseEvent
  ) => {
    const eventCommomProps = {
      type: eventType,
      device: isMobile ? 'mobile' : 'desktop',
      source: eventsSource,
      isVerified: truckerData?.isVerified,
    };

    sendAmplitude('trucker_profile_contact_exclude_modal', {
      ...eventCommomProps,
      freightCode: freight?.code || textConstants.notAvailaible,
      truckerId: truckerData?.trucker?.id,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_contact_exclude_modal',
        data: {
          ...eventCommomProps,
          freightCode: createHashString(freight?.code, ''),
          truckerId: `hashed|${truckerData?.trucker?.id}`,
        },
        clickEvent: event,
      },
      'trucker_profile'
    );
  };

  return { addRemoveFromContactListEvent, modalConfirmRemoveFromContactListEvent, negotiationStartedEvent };
};

export default useMenuEvents;
